






















import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatPageHeader',
  props: {
    to: {
      type: String as PropType<string>,
    },
    isShow: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    onClick: {
      type: Function as PropType<Function>,
      default: () => false,
    },
    isUnread: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
  },
});
